import { StorefrontImage } from "../../types";
import { VinoDataOffer } from "../../types/vino-data-types";
import { generateStorefrontImage } from "../../utils/generate-storefront-image";
import { isSingleVinoDataWineSKU } from "./sku";
import config from "../../../config.json";
import mysteryBottleImg from "../../images/mystery-bottle.png";
import mysteryBottleImgFull from "../../images/mystery-bottle-full.png";

export const thumbnailFromVinoDataWineOffer = ({
  cardImage,
  sku,
}: VinoDataOffer): StorefrontImage => {
  const [wine] = sku?.wines ?? [];

  const image =
    isSingleVinoDataWineSKU(sku) && wine ? wine.bottleImage : cardImage;

  return generateStorefrontImage(image, { height: 80 });
};

export const roundelsImageFromVinoDataWineOffer = ({
  roundelsImage,
}: VinoDataOffer): StorefrontImage => {
  return roundelsImage
    ? generateStorefrontImage(roundelsImage, { width: 120 })
    : null;
};

export const cardImageFromVinoDataWineOffer = ({
  cardImage,
  sku,
  productCardLayout,
  isOffersCollection,
}: VinoDataOffer): StorefrontImage => {
  const [wine] = sku?.wines ?? [];

  return productCardLayout &&
    productCardLayout === "Two Column"
    ? generateStorefrontImage(wine.bottleImage, { width: 255 })
    : isSingleVinoDataWineSKU(sku) && wine
    ? generateStorefrontImage(cardImage || wine.bottleImage, { width: 120 })
    : generateStorefrontImage(cardImage, { height: 255 });
};

export const heroImageFromVinoDataOffer = ({
  cardImage,
  sku,
  secret,
  hasHeroImages,
}: VinoDataOffer): StorefrontImage => {
  const [wine] = sku?.wines ?? [];
  const image =
    isSingleVinoDataWineSKU(sku) && secret
      ? wine.secretBottleImage || { url: mysteryBottleImgFull }
      : isSingleVinoDataWineSKU(sku) && !hasHeroImages
      ? wine.bottleImage
      : cardImage;

  return generateStorefrontImage(image, { height: 630 });
};

export const largeHeroImageFromVinoDataOffer = ({
  detailsImageLarge,
  sku,
  hasHeroImages,
}: VinoDataOffer): StorefrontImage => {
  const [wine] = sku?.wines ?? [];
  let returnVal = generateStorefrontImage(detailsImageLarge, { height: 960 });
  if (
    isSingleVinoDataWineSKU(sku) &&
    wine &&
    wine.relativeSizedBottleImage &&
    !hasHeroImages
  )
    returnVal = generateStorefrontImage(wine.relativeSizedBottleImage, {
      width: 120,
    });
  return returnVal;
};

export const wideHeroImageFromVinoDataOffer = ({
  detailsImageWide,
  sku,
  hasHeroImages,
}: VinoDataOffer): StorefrontImage => {
  const [wine] = sku?.wines ?? [];
  let returnVal = generateStorefrontImage(detailsImageWide, { height: 1060 });
  if (
    isSingleVinoDataWineSKU(sku) &&
    wine &&
    wine.relativeSizedBottleImage &&
    !hasHeroImages
  )
    returnVal = generateStorefrontImage(wine.relativeSizedBottleImage, {
      width: 120,
    });
  return returnVal;
};

export const relativeSizedHeroImageFromVinoDataOffer = ({
  cardImage,
  sku,
  secret,
}: VinoDataOffer): StorefrontImage => {
  const [wine] = sku?.wines ?? [];

  let returnVal = generateStorefrontImage(cardImage, { height: 817 });
  if (isSingleVinoDataWineSKU(sku)) {
    if (wine.relativeSizedBottleImage) {
      returnVal = generateStorefrontImage(wine.relativeSizedBottleImage, {
        width: 120,
      });
    }
    if (secret && wine.secretRelativeBottleImage) {
      returnVal = generateStorefrontImage(wine.secretRelativeBottleImage, {
        width: 120,
      });
    }
    if (secret && !wine.secretRelativeBottleImage) {
      const image: any = {
        url: mysteryBottleImg,
      };
      returnVal = generateStorefrontImage(image, { height: 120 });
    }
  }
  return returnVal;
};
